<template>
  <md-card class="min-h-[500px]">
    <md-card-header class="md-card-header-text md-card-header-green">
      <div class="card-text">
        <h4 class="title text-lg">{{ $t("student.test_scores") }}</h4>
      </div>
    </md-card-header>
    <md-card-content v-if="studentData">
      <div
        class="pl-10 pt-1"
        v-for="(item, index) in listRouterIndividual"
        :key="'list' + index"
      >
        <router-link
          :to="{
            name: individual_assessment_name,
            query: {
              tabActive: item.tabActive,
              tabName: item.name,
              id: studentData._id
            }
          }"
        >
          <div>
            <span class="text-gray-400"><i class="fas fa-book-open"></i></span
            ><span class="text-[#215BCD] pl-4 underline">{{
              $t(item.title)
            }}</span>
          </div></router-link
        >
        <br />
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import { individual_assessment_name } from "@/routes/routes";
const listRouterIndividual = [
  {
    name: "IELTS",
    title: "student.click_to_view_scores_of_IELTS_tests",
    tabActive: 4
  },
  {
    name: "TOEFL",
    title: "student.click_to_view_scores_of_TOEFL_tests",
    tabActive: 5
  },
  {
    name: "SAT",
    title: "student.click_to_view_scores_of_SAT_tests",
    tabActive: 6
  },
  {
    name: "SRI_SMI",
    title: "student.click_to_view_scores_of_SRISMI_tests",
    tabActive: 0
  },
  {
    name: "ACT",
    title: "student.click_to_view_scores_of_ACT_tests",
    tabActive: 1
  },
  {
    name: "SBAC",
    title: "student.click_to_view_scores_of_SBAC_tests",
    tabActive: 2
  },
  {
    name: "physical",
    title: "student.click_to_view_index_of_Physical_performance_measures",
    tabActive: 3
  }
];
export default {
  props: ["studentData"],
  data() {
    return {
      individual_assessment_name,
      listRouterIndividual: listRouterIndividual
    };
  },
  methods: {
    viewScore() {
      this.$router.push(`/individual-assessment`);
    }
  }
};
</script>
<style></style>
